import React from 'react'

import Header from 'components/Text/Header'
import CrossButton from 'components/Buttons/CrossButton'
import {
	Container,
	TokenRow,
	TokenIcon,
	ResumeIcon,
	Token,
	HorizontalSeparator,
	GotItButton,
} from './WhatAreTokens.styles'

interface WhatAreTokensProps {
	onGotIt: () => any,
	onClose: () => any,
}

export default function WhatAreTokens(
	{
		onClose,
		onGotIt,
		...props
	}: WhatAreTokensProps,
) {

	return (
		<Container {...props}>
			<Header>
				What are tokens?
			</Header>
			<CrossButton
				onClick={onClose}
			/>
			<p className='useTokens'>
				To view resumes of candidates
				that apply for your job postings,
				you must use tokens.
			</p>
			<TokenRow>
				<div>
					<TokenIcon />
					1 token
				</div>
				<p className='equals'>
					=
				</p>
				<div>
					<ResumeIcon />
					1 resume
				</div>
			</TokenRow>
			<p className='firstTokens'>
				Your first 2 tokens are free.
			</p>
			<Token
				id={0}
				count={2}
				countryCode={'CA'}
				price={'Free!'}
			/>
			<HorizontalSeparator />
			<GotItButton
				onClick={onGotIt}
			>
				Got it
			</GotItButton>
		</Container>
	)
}
